/**
 * Licence status helpers (Ray 2026-10-04: every paid licence is LIFETIME).
 *
 * 'lifetime' is its own status from the server (licenseEndsAt null). Before
 * this, every screen spelled "licence is running" as `status === 'active'`,
 * so a lifetime vendo would have shown "Inactive" with an Activate button —
 * the compiler finds none of those sites. Use these instead of comparing to
 * 'active' directly.
 */

export type LicenseStatusValue =
   | 'unactivated'
   | 'trial'
   | 'active'
   | 'expired'
   | 'lifetime';

/** Paid and running: a lifetime, or an old 1-year licence not yet converted. */
export const isLicensed = (s: string | null | undefined): boolean =>
   s === 'active' || s === 'lifetime';

/** Text for the licence chip on a vendo card / row. */
export function licenseChipText(
   s: string | null | undefined,
   trialDaysLeft?: number | null
): string {
   if (s === 'lifetime') return '✓ Lifetime';
   if (s === 'active') return '✓ Active';
   if (s === 'trial') return `Trial · ${trialDaysLeft ?? 0}d`;
   if (s === 'expired') return '⚠ Expired';
   return '🔒 Not activated';
}
